import { render, staticRenderFns } from "./MMaterialListDetail.vue?vue&type=template&id=6a9e85c5&scoped=true&"
import script from "./MMaterialListDetail.vue?vue&type=script&lang=ts&"
export * from "./MMaterialListDetail.vue?vue&type=script&lang=ts&"
import style0 from "./MMaterialListDetail.vue?vue&type=style&index=0&id=6a9e85c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9e85c5",
  null
  
)

export default component.exports